import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://453a5e9d0994fb73d56adb58bd3483bc@o4510779139358720.ingest.de.sentry.io/4510779143028816",
  sendDefaultPii: false,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  ignoreErrors: [
    "ResizeObserver loop",
    "ResizeObserver loop completed with undelivered notifications",
    "Non-Error promise rejection captured",
    "Load failed",
    "Failed to fetch",
    "NetworkError",
    "Network request failed",
    "AbortError",
    "TypeError: cancelled",
    "TypeError: Cancelled",
    "NotAllowedError",
    "ChunkLoadError",
    "Loading chunk",
    "Loading CSS chunk",
    /^Object Not Found Matching Id/,
  ],
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-extension:\/\//i,
    /^safari-web-extension:\/\//i,
    /translate\.google/i,
    /googleusercontent\.com/i,
  ],
  beforeSend(event) {
    const frames = event.exception?.values?.[0]?.stacktrace?.frames;
    if (frames?.some((f) => f.filename?.includes("extension://"))) {
      return null;
    }
    if (event.request) {
      delete event.request.cookies;
      delete event.request.data;
    }
    return event;
  },
});
